// assets
import { IconDashboard, IconChartBar } from '@tabler/icons-react';

// constant
const icons = {
    IconDashboard,
    IconChartBar
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    //title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'reports',
            title: 'Dashboard',
            type: 'item',
            url: '/',
            icon: icons.IconChartBar,
            breadcrumbs: false
        },
        {
            id: 'default',
            title: 'Dashboard 2',
            type: 'item',
            url: '/dashboard2',
            icon: icons.IconDashboard,
            breadcrumbs: false,
            superuserOnly: true  // Visível apenas para superusuários
        }
    ]
};

export default dashboard;
